import { SimpleLayout } from '@boozt/app/components/templates';
import { useApp } from '@boozt/app/context';
import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import { InfoBanner } from 'palette/InfoBanner';
import { TextLink } from 'palette/TextLink';
import './NotFound.scss';

export default function NotFound() {
    const { page } = useApp();
    const [block, element] = BEMBlock('error-not-found');

    return (
        <SimpleLayout>
            <div className={classNames(block)}>
                <InfoBanner
                    subtitle="Sorry about that, we couldn't find the page you were looking for."
                    theme="negative"
                    title="Oops! Page Not Found"
                />
                <TextLink
                    className={element('link')}
                    href="/"
                    transform="uppercase"
                    weight="bold"
                >
                    {page.description}
                </TextLink>
            </div>
        </SimpleLayout>
    );
}
